import { SystemRoles } from "../../providers/roles";
import {
  expertGenderFilterList,
  statesList,
} from "../../pages/pro/createEditProfile/formFragments/constants";

const statusOptions = [
  "Active",
  "Inactive",
  "In Review",
  "In Negotiation",
  "Prospect",
];

export const usertypeOptions = [
  {
    id: SystemRoles.PRO.toString(),
    name: 'Expert',
  },
  {
    id: SystemRoles.PRO_TEAM_ADMIN.toString(),
    name: 'Expert Team',
  },
  {
    id: SystemRoles.ACCOUNT_MANAGER_ADMIN.toString(),
    name: 'Account Manager',
  },
  {
    id: SystemRoles.POST_PRODUCTION_ADMIN.toString(),
    name: 'Fulfillment',
  },
  { 
    id: SystemRoles.SALES_TEAM.toString(),
    name: 'Sales Team',
  },
  {
    id: SystemRoles.BRAND_ADMIN.toString(),
    name: 'Brand Admin',
  },
  {
    id: SystemRoles.BRAND_MEMBER.toString(),
    name: 'Brand Member',
  },
  {
    id: SystemRoles.ADMIN.toString(),
    name: 'Admin',
  },
  {
    id: 'creator',
    name: 'Creator (Deprecated)'
  },
  {
    id: 'shopper',
    name: 'Shopper (Deprecated)'
  }
]

const headshotOptions = ["Present", "Not Present"];

const introVideoOptions = ["Present", "Not Present"];

const isParentOptions = ["Yes", "No"];

const tierOptions = ["1", "2", "3", "4", "5", "6"];

const optStatusOptions = ["Opt-In Pending", "Opted In"];

const ethnicityOptions = [
  "American Indian or Alaska Native",
  "Hispanic/Latino",
  "East Asian",
  "South Asian",
  "Black or African American",
  "Native Hawaiian or Other Pacific Islander",
  "White",
  "Two or More Races",
  "No Response",
];

const regionOptions = ["West", "East", "Midwest", "Southeast", "Northeast"];

const stateOptions = statesList;

interface IFilterArray {
  title: string;
  filterKey: string;
  options?: Array<string | { value: string; label: string }>;
  getOptions?: {
    optionKey: string;
    optionMethod: Function;
  };
  isAutoComplete?: boolean;
  isAutoCompleteKeyValue?: boolean;
}

export const FilterArray: Array<IFilterArray> = [
  {
    title: "Status",
    filterKey: "status",
    options: statusOptions,
  },
  {
    title: "Opt-In Status",
    filterKey: "optStatus",
    options: optStatusOptions,
  },
  {
    title: "Headshot",
    filterKey: "headshot",
    options: headshotOptions,
  },
  {
    title: "Intro Video",
    filterKey: "introVideo",
    options: introVideoOptions,
  },
  {
    isAutoCompleteKeyValue: true,
    title: "Profession",
    filterKey: "profession",
    options: [],
  },
  {
    isAutoCompleteKeyValue: true,
    title: "Sub-Profession",
    filterKey: "subprofession",
  },
  {
    title: "Tier",
    filterKey: "tier",
    options: tierOptions,
  },
  {
    title: "Gender",
    filterKey: "gender",
    options: expertGenderFilterList,
  },
  {
    isAutoComplete: true,
    title: "Ethnicity",
    filterKey: "ethnicity",
    options: ethnicityOptions,
  },
  {
    title: "Is Parent",
    filterKey: "isParent",
    options: isParentOptions,
  },
  {
    title: "Region",
    filterKey: "region",
    options: regionOptions,
  },
  {
    isAutoComplete: true,
    title: "State",
    filterKey: "state",
    options: stateOptions,
  },
];

export const getValueAsEvent = (value?: string) =>
  ({
    target: { value: value || "" },
  } as any);
